import { styled } from 'linaria/react';

const ProductCardStickyContainerDefault = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-150);
  float: right;
  position: sticky;
  top: 152px;
  box-shadow: var(--box-shadow-m);
  border-radius: var(--rounding-m);
  border-right: 1px solid var(--control-minor);
`;

export const ProductCardStickyReviewsFormContainer = styled(ProductCardStickyContainerDefault)`
  width: 220px;
  padding: var(--space-250);

  @media (--only-largeDesktop) {
    width: 280px;
  }
`;
